import axios from "axios";
// creating axios instance
export const codeSkillsApi = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});
export const CodeSkillProfileApi = axios.create({
    baseURL: process.env.REACT_APP_PROFILE_API
})
